import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgHydrocortisoneGlyphSecondary(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M39.44 33.11c-.39-.1-.81.13-.92.53-.64 2.41-2.43 4.86-4.62 4.86-2.62 0-4.91-3.34-4.91-7.14 0-3.72 2.2-6.74 4.91-6.74 2.04 0 3.89 1.77 4.61 4.42a.75.75 0 1 0 1.45-.39c-.89-3.31-3.33-5.53-6.06-5.53-.15 0-.29.02-.44.03h-.02l-10.71.01V8.75a.74.74 0 0 0-.74-.75c-.41 0-.75.34-.75.75v14.41l-11.74.01V8.75a.749.749 0 1 0-1.5 0V39.24c0 .42.34.76.75.76s.75-.34.75-.75V24.67l11.74-.01v14.59c0 .41.34.75.75.75s.75-.34.75-.75V24.66l7.46-.01c-1.63 1.49-2.71 3.94-2.71 6.71 0 4.68 2.94 8.64 6.41 8.64 2.64 0 5.14-2.46 6.07-5.97a.75.75 0 0 0-.53-.92Z",
    fill: "currentColor"
  }));
}

export { SvgHydrocortisoneGlyphSecondary as default };
